export const ATTR_EDITABLE_SELECTOR = '[data-fv-editable]';
export const CLICKABLE_SELECTOR = '[data-fv-clickable], [role=button]';
export const PLAINTEXT_SELECTOR = '[data-fv-xd-xctname=PlainText]';
export const ctrlIdSelector = (ctrlId) => `[data-fv-xd-ctrlid="${ctrlId}"]`;
export const ATTR_FV_ID = 'data-fv-id';
export const ATTR_FV_DS = 'data-fv-ds';
export const ATTR_XMLTOEDIT = 'data-fv-xd-xmlToEdit';
export const ATTR_ON_VALUE = 'data-fv-xd-onValue';
export const ATTR_OFF_VALUE = 'data-fv-xd-offValue';
export const ATTR_CONTEXT = 'data-fv-context';
export const ATTR_ACTION = 'data-fv-xd-action';
export const ATTR_DISABLE_EDITING = 'data-fv-xd-disableEditing';
export const ATTR_DISABLED = 'disabled';
export const ATTR_AUTO_ADVANCE = 'data-fv-xd-autoadvance';
export const ATTR_HAS_VALIDATION_ERROR = 'data-fv-has-error';
export const ATTR_HAS_VALUE = 'data-fv-has-value';
export const ATTR_XD_REF = 'data-fv-xd-ref';
export const ATTR_BINDING = 'data-fv-xd-binding';
export const ATTR_BINDING_SECONDARY = 'data-fv-xd-binding_secondary';
